import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom";
export const ReactRailsUJS = {
  CLASS_NAME_ATTR: "data-react-class",
  PROPS_ATTR: "data-react-props",
  RENDER_ATTR: "data-hydrate",
  CACHE_ID_ATTR: "data-react-cache-id",
  TURBOLINKS_PERMANENT_ATTR: "data-turbolinks-permanent",
  jQuery: typeof window !== "undefined" && typeof window.jQuery !== "undefined" && window.jQuery,
  components: {},
  findDOMNodes: searchSelector => {
    var classNameAttr = ReactRailsUJS.CLASS_NAME_ATTR;
    var selector, parent;
    switch (typeof searchSelector) {
      case "undefined":
        selector = "[" + classNameAttr + "]";
        parent = document;
        break;
      case "object":
        selector = "[" + classNameAttr + "]";
        parent = searchSelector;
        break;
      case "string":
        selector = searchSelector + "[" + classNameAttr + "], " + searchSelector + " [" + classNameAttr + "]";
        parent = document;
        break;
      default:
        break;
    }
    if (ReactRailsUJS.jQuery) {
      return ReactRailsUJS.jQuery(selector, parent);
    } else {
      return parent.querySelectorAll(selector);
    }
  },
  useContext: _ => {
    return null;
  },
  useContexts: _ => {
    return null;
  },
  serverRender: _ => {
    return null;
  },
  mountComponents: async searchSelector => {
    var ujs = ReactRailsUJS;
    var nodes = ujs.findDOMNodes(searchSelector);
    for (var i = 0; i < nodes.length; ++i) {
      var node = nodes[i];
      var className = node.getAttribute(ujs.CLASS_NAME_ATTR);
      var propsJson = node.getAttribute(ujs.PROPS_ATTR);
      var props = propsJson && JSON.parse(propsJson);
      var hydrate = node.getAttribute(ujs.RENDER_ATTR);
      var cacheId = node.getAttribute(ujs.CACHE_ID_ATTR);
      var turbolinksPermanent = node.hasAttribute(ujs.TURBOLINKS_PERMANENT_ATTR);
      var component = ujs.components[cacheId];
      if (component === undefined) {
        const LazyModule = /*#__PURE__*/lazy(() => import(`../components/${className.replace("/index", "")}/index`));
        ReactDOM.render( /*#__PURE__*/React.createElement(Suspense, {
          fallback: ""
        }, /*#__PURE__*/React.createElement(LazyModule, props)), node);
        ujs.components[cacheId] = component;
      }
    }
  },
  unmountComponents: searchSelector => {
    var nodes = ReactRailsUJS.findDOMNodes(searchSelector);
    for (var i = 0; i < nodes.length; ++i) {
      var node = nodes[i];
      ReactDOM.unmountComponentAtNode(node);
    }
  },
  detectEvents: () => {
    if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", e => {
        ReactRailsUJS.handleMount(e);
      });
    } else {
      ReactRailsUJS.mountComponents();
    }
    window.addEventListener("turbolinks:load", e => {
      ReactRailsUJS.handleMount(e);
    });
  },
  handleMount: e => {
    var target = undefined;
    if (e && e.target) {
      target = e.target;
    }
    ReactRailsUJS.mountComponents(target);
  },
  handleUnmount: e => {
    var target = undefined;
    if (e && e.target) {
      target = e.target;
    }
    ReactRailsUJS.unmountComponents(target);
  }
};
ReactRailsUJS.detectEvents();
export default ReactRailsUJS;